
export const payload = {
    acquirer_token: {
        client_id: "",
        client_secret: "",
    }, 
   
}

export default {
    items:[],
    payload,
    status: 200, 
}